const name = 'circle-s';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path d="M31 55.5c-1.602 0-3.287-.083-5.054-.249-1.768-.165-3.618-.524-5.552-1.077l.746-4.557c2.099.553 3.95.925 5.551 1.119 1.602.193 2.956.29 4.06.29 1.658 0 2.942-.36 3.853-1.077.912-.719 1.367-1.575 1.367-2.569 0-.939-.372-1.671-1.118-2.196-.746-.524-1.685-.994-2.817-1.408a62.85 62.85 0 00-3.646-1.202 15.433 15.433 0 01-3.646-1.615 9.679 9.679 0 01-2.817-2.569c-.746-1.022-1.118-2.389-1.118-4.101 0-1.381.276-2.569.828-3.563a7.192 7.192 0 012.196-2.445c.911-.635 1.988-1.09 3.231-1.367A18.103 18.103 0 0131 26.5c1.602 0 3.176.11 4.723.331 1.547.221 3.287.608 5.22 1.16l-1.16 4.392c-1.878-.497-3.522-.843-4.93-1.036-1.409-.193-2.665-.29-3.77-.29-1.657 0-2.845.304-3.563.912-.718.607-1.077 1.38-1.077 2.32 0 .883.373 1.588 1.118 2.112.746.525 1.685.967 2.818 1.326 1.132.36 2.347.732 3.645 1.119 1.298.386 2.513.897 3.646 1.533a8.533 8.533 0 012.817 2.527c.746 1.05 1.119 2.403 1.119 4.06 0 2.927-1.022 5.082-3.066 6.463-2.044 1.38-4.557 2.071-7.54 2.071z" fill="#FFF"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'S',
};

export default icon;
